"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteroidStandardProject = void 0;
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var constants_1 = require("../../../constants");
var StandardProjectCard_1 = require("../../StandardProjectCard");
var PartyHooks_1 = require("../../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../../turmoil/parties/PartyName");
var constants = require("../../../constants");
var AsteroidStandardProject = (function (_super) {
    __extends(AsteroidStandardProject, _super);
    function AsteroidStandardProject() {
        return _super.call(this, {
            name: CardName_1.CardName.ASTEROID_STANDARD_PROJECT,
            cost: 14,
            metadata: {
                cardNumber: 'SP9',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    return b.standardProject('Spend 14 M€ to raise temperature 1 step.', function (eb) {
                        eb.megacredits(14).startAction.temperature(1);
                    });
                }),
            },
        }) || this;
    }
    AsteroidStandardProject.prototype.canAct = function (player) {
        var asteroidCost = this.cost;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS))
            asteroidCost += constants_1.REDS_RULING_POLICY_COST;
        return player.canAfford(asteroidCost) && player.game.getTemperature() < constants.MAX_TEMPERATURE;
    };
    AsteroidStandardProject.prototype.actionEssence = function (player) {
        player.game.increaseTemperature(player, 1);
    };
    return AsteroidStandardProject;
}(StandardProjectCard_1.StandardProjectCard));
exports.AsteroidStandardProject = AsteroidStandardProject;
//# sourceMappingURL=AsteroidStandardProject.js.map